import '@firebase/auth-compat';
//# sourceMappingURL=index.esm.js.map
